var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BrowserXhr } from '@angular/http';
var ProgressBrowserXhr = /** @class */ (function (_super) {
    __extends(ProgressBrowserXhr, _super);
    function ProgressBrowserXhr(_progressService) {
        var _this = _super.call(this) || this;
        _this._progressService = _progressService;
        return _this;
    }
    ProgressBrowserXhr.prototype.build = function () {
        var xhr = _super.prototype.build.call(this);
        var progressCallback = this._progressService.use();
        if (progressCallback) {
            xhr.upload.addEventListener('progress', function (event) {
                var progressPercent = Math.round(100 * event.loaded / event.total);
                progressCallback.call(window, progressPercent);
            });
        }
        return xhr;
    };
    return ProgressBrowserXhr;
}(BrowserXhr));
export { ProgressBrowserXhr };
var ProgressService = /** @class */ (function () {
    function ProgressService() {
    }
    ProgressService.prototype.register = function (callback) {
        this._callback = callback;
    };
    ProgressService.prototype.use = function () {
        var callback = this._callback;
        this._callback = null;
        return callback;
    };
    return ProgressService;
}());
export { ProgressService };
